var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.widget.styles)},[_vm._l((_vm.widget.items),function(item,idx){return [_c('form-item',{key:idx,attrs:{"model":_vm.model,"widget":item,"remote-data":_vm.remoteData}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }